export default __webpack_public_path__ + "static/media/311.a3bae8bf.jpg";